//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React, { createContext, useContext } from 'react';

interface PurchaseOptionsContextValue {
  readOnly: boolean;
}

const PurchaseOptionsContext = createContext<
  PurchaseOptionsContextValue | undefined
>(undefined);

interface PurchaseOptionsProviderProps {
  children: React.ReactNode;
  readOnly: boolean;
}

export const PurchaseOptionsProvider = ({
  children,
  readOnly,
}: PurchaseOptionsProviderProps) => {
  return (
    <PurchaseOptionsContext.Provider value={{ readOnly }}>
      {children}
    </PurchaseOptionsContext.Provider>
  );
};

export const usePurchaseOptionsContext = () => {
  const context = useContext(PurchaseOptionsContext);
  if (!context) {
    throw new Error(
      'usePurchaseOptionsContext must be used within PurchaseOptionsProvider',
    );
  }
  return context;
};
